import React from "react"
import { Redirect, Route, Switch } from "react-router"
import { Login, PharmacyLogin, BackToNormal } from "../component/Account"

const Account: React.FC = React.memo(() => {

    return <Switch>
        <Route exact={true} path="/" component={() => <Redirect to="/login" />} />
        <Route path="/login" component={Login} />
        <Route path="/pharmacy-login/:pharmacistToken" component={PharmacyLogin} />
        <Route path="/back-to-normal" component={BackToNormal} />
    </Switch>
})

export default Account